import { CLAUDE_PROMPT_SECTIONS } from "@/rbac/links.js";

import {
  CREATE_CLAUDE_PROMPT_SECTION,
  SORT_CLAUDE_PROMPT_SECTION,
  UPDATE_CLAUDE_PROMPT_SECTION,
  VIEW_CLAUDE_PROMPT_SECTION,
} from "@/rbac/permissions.js";

function props(route) {
  let orderByDefault = route.query.order_by_order || "asc";

  if (route.query.order_by_id || route.query.order_by_name) {
    orderByDefault = null;
  }

  return {
    page: parseInt(route.query.page) || 1,
    limit: parseInt(route.query.limit) || 10,

    id: parseInt(route.query.id) || null,
    order_by_id: route.query.order_by_id || null,

    order: parseInt(route.query.order) || null,
    order_by_order: orderByDefault,

    name: route.query.name || null,
    order_by_name: route.query.order_by_name || null,
  };
}

const claudePromptSectionRoutes = [
  {
    path: "/nacd-ai-prompt-sections",
    component: () =>
      import(
        /* webpackChunkName: "system-layout" */ "@/views/system/Layout.vue"
      ),
    children: [
      {
        path: "",
        name: "ClaudePromptSectionIndex",
        meta: {
          title: "NACD AI Prompt Sections",
          permission: CLAUDE_PROMPT_SECTIONS,
        },
        props: (route) => props(route),
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-section-index" */ "@/views/system/claude-prompt-section/Index.vue"
          ),
      },
      {
        path: "create",
        name: "ClaudePromptSectionCreate",
        meta: {
          title: "Create NACD AI Prompt Section",
          permission: CREATE_CLAUDE_PROMPT_SECTION,
        },
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-section-create" */ "@/views/system/claude-prompt-section/Create.vue"
          ),
      },
      {
        path: "sort",
        name: "ClaudePromptSectionSort",
        meta: {
          title: "Sort NACD AI Prompt Sections",
          permission: SORT_CLAUDE_PROMPT_SECTION,
        },
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-section-sort" */ "@/views/system/claude-prompt-section/Sort.vue"
          ),
      },
      {
        path: ":id/edit",
        name: "ClaudePromptSectionEdit",
        meta: {
          title: "Edit NACD AI Prompt Section",
          permission: UPDATE_CLAUDE_PROMPT_SECTION,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-section-edit" */ "@/views/system/claude-prompt-section/Edit.vue"
          ),
      },
      {
        path: ":id/view",
        name: "ClaudePromptSectionView",
        meta: {
          title: "View NACD AI Prompt Section",
          permission: VIEW_CLAUDE_PROMPT_SECTION,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-section-view" */ "@/views/system/claude-prompt-section/View.vue"
          ),
      },
    ],
  },
];

export default claudePromptSectionRoutes;
